import type { ReactNode } from 'react';
import {
  PageAgentRendererContext,
  type RenderPageAgentChat,
} from '../../model/page-agent-renderer';

/** Installed once by the app, so every page's agent dock can draw its chat. */
export function PageAgentRendererProvider({
  render,
  children,
}: {
  render: RenderPageAgentChat;
  children: ReactNode;
}) {
  return (
    <PageAgentRendererContext.Provider value={render}>{children}</PageAgentRendererContext.Provider>
  );
}
